<template>
  <v-layout column>
    <v-toolbar>
      <v-toolbar-title>Búsqueda de Clientes</v-toolbar-title>
    </v-toolbar>

    <v-container grid-list-sm>
      <!-- Cuadro de búsqueda -->
      <v-layout row>
        <v-flex xs12 sm6>
          <v-btn-toggle v-model="searchField" mandatory>
            <v-btn color="success" small text value="Documento"
              >Documento</v-btn
            >
            <v-btn color="info" small text value="Cuil">CUI(L/T)</v-btn>
            <v-btn color="error" small text value="Nombre">Nombre</v-btn>
            <v-btn color="warning" small text value="Operacion"
              >Nº Crédito</v-btn
            >
          </v-btn-toggle>
          <p></p>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs10>
          <v-text-field
            v-model="searchValue"
            required
            v-on:keyup="searchValueKeyUp"
          >
            <template v-slot:label>
              Buscar por {{ searchField }}
            </template>
          </v-text-field>
        </v-flex>
        <v-flex xs2>
          <v-btn icon @click="search">
            <v-icon>search</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>

    <div class="text-xs-center">
      <v-progress-linear v-show="loading" indeterminate></v-progress-linear>
    </div>

    <v-list three-line dense>
      <template v-for="(item, index) in searchResults">
        <v-subheader v-if="item.header" :key="item.header">
          {{ item.header }}
        </v-subheader>
        <v-divider
          v-else-if="item.divider"
          :inset="item.inset"
          :key="index"
        ></v-divider>

        <v-list-item v-else :key="item.personaId" @click="verInfo(item)">
          <!-- <v-list-item-avatar> -->
          <v-speed-dial direction="right" open-on-hover>
            <template v-slot:activator>
              <v-btn large slot="activator" color="orange" fab text>
                <v-icon color="orange">touch_app</v-icon>
              </v-btn>
            </template>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  fab
                  dark
                  small
                  color="green"
                  v-on="on"
                  top
                  @click="verCreditos(item)"
                >
                  <v-icon>playlist_add_check</v-icon>
                </v-btn>
              </template>
              <span>Ver Créditos</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  fab
                  dark
                  small
                  color="purple"
                  v-on="on"
                  top
                  :to="item.viewLegajo"
                >
                  <v-icon>person</v-icon>
                </v-btn>
              </template>
              <span>Ver Legajo</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  fab
                  dark
                  small
                  color="indigo"
                  v-on="on"
                  top
                  @click="verContactos(item)"
                >
                  <v-icon>history</v-icon>
                </v-btn>
              </template>
              <span>Ver Contactos</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  fab
                  dark
                  small
                  color="blue"
                  v-on="on"
                  @click="verLegajoVirtual(item)"
                >
                  <v-icon>file_copy</v-icon>
                </v-btn>
              </template>
              <span>Legajo Virtual</span>
            </v-tooltip>
          </v-speed-dial>
          <!-- </v-list-item-avatar> -->

          <v-list-item-content>
            <v-list-item-title v-html="item.title"></v-list-item-title>
            <v-list-item-subtitle
              class="caption"
              v-html="item.subtitle"
            ></v-list-item-subtitle>
            <!-- <v-list-item-subtitle class="caption" v-html="item.avisos"></v-list-item-subtitle>-->
          </v-list-item-content>
          <v-list-item-icon v-if="item.avisos">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                  v-on="on"
                  v-if="item && item.avisos.includes('Lista negra')"
                  color="black"
                  >thumb_down</v-icon
                >
                <v-icon
                  v-on="on"
                  v-else-if="item && item.avisos.includes('Baja')"
                  color="red"
                  >thumb_down</v-icon
                >
              </template>
              <span
                >{{
                  !item.avisos || item.avisos == ''
                    ? 'Cliente Activo'
                    : item.avisos.includes('Lista negra')
                    ? item.avisos
                    : item.avisos.includes('Baja')
                    ? 'Dado de Baja'
                    : ''
                }}
              </span>
            </v-tooltip>
          </v-list-item-icon>

          <v-list-item-icon v-if="item.tieneReclamoActivo">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" color="red">report</v-icon>
              </template>
              <span> Reclamo Activo </span>
            </v-tooltip>
          </v-list-item-icon>

          <v-list-item-icon v-if="item.alertas && item.alertas.length > 0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-chip
                  small
                  v-on="on"
                  color="red"
                  dark
                  @click="verAlertas(item)"
                  >Alerta</v-chip
                >
                <!-- <v-icon v-on="on" color="warning" @click="verAlertas(item)">warning</v-icon> -->
              </template>
              <span> HAY ALERTAS </span>
            </v-tooltip>
          </v-list-item-icon>

          <v-list-item-icon>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" v-if="item" :color="item.clasificacionColor"
                  >info</v-icon
                >
              </template>
              <span>{{ item.clasificacion }} </span>
            </v-tooltip>
          </v-list-item-icon>
        </v-list-item>
      </template>
    </v-list>

    <div class="text-xs-center pt-2">
      <v-pagination
        v-model="pagination.page"
        :length="pages"
        :total-visible="5"
        circle
      ></v-pagination>
      <p></p>
    </div>

    <v-card>
      <v-card-title primary-title>
        <div>
          <div class="d-flex justify-space-between align-center mb-4">
            <div class="subtitle-1">Más información</div>
            <v-btn
              color="info"
              small
              @click="verResumenEjecutivo(selectedPersona)"
              v-if="
                selectedPersona.personaId &&
                  checkCanAccess('ap-ver-resumen-ejecutivo')
              "
              >Resumen Ejecutivo</v-btn
            >
          </div>
          <v-banner
            dark
            :color="selectedPersona.clasificacionColor"
            elevation="5"
          >
            <span class="overline">{{ selectedPersona.clasificacion }}</span>
          </v-banner>
          <v-banner icon="info" elevation="5">
            <span class="caption">{{ selectedPersona.masInfo }}</span>
          </v-banner>
          <v-banner dark color="indigo" elevation="5">
            <span class="overline">{{ selectedPersona.cuentasBanco }}</span>
          </v-banner>
        </div>
      </v-card-title>
    </v-card>

    <!-- Ver Crédios de Cliente  -->
    <!-- <app-lista-creditos :visible="showListaCreditos" :personaId="selectedPersonaId" @close="showListaCreditos=false"></app-lista-creditos> -->

    <!-- Ver Legajo Virtual  -->
    <v-dialog v-model="showLegajoVirtual" persistent width="700">
      <legajo-virtual
        :documento="selectedPersonaDocumento"
        @close-dialog="showLegajoVirtual = false"
      >
      </legajo-virtual>
    </v-dialog>

    <v-dialog v-model="showAlertas" width="500">
      <app-alertas
        :Lista="selectedPersona.alertas"
        @close-dialog="showAlertas = false"
      >
      </app-alertas>
    </v-dialog>
  </v-layout>
</template>

<script>
import Vue from 'vue';

import { http } from '@/axios';
import LegajoVirtual from '@/components/legajo/legajoVirtual.vue';

import { mapGetters, mapMutations } from 'vuex';

export default {
  components: {
    'legajo-virtual': LegajoVirtual,
  },
  data: function() {
    return {
      fab: false,
      loading: false,
      searchValue: '',
      searchField: 'Documento',
      items: [],
      totalItems: 0,
      pagination: {
        // definición de paginación
        descending: false,
        page: 1,
        rowsPerPage: 5,
        sortBy: '',
        rowsPerPageItems: [5, 10, 15, 20, 50],
      },
      searchResults: [
        { header: 'Resultados' },
        {
          avatar: 'https://cdn.vuetifyjs.com/images/lists/1.jpg',
          title: 'Sosa, Maximiliano',
          avisos: '',
          subtitle:
            "<span class='text--primary'>D.N.I. 24.312.434</span> &mdash; Buen Cliente, avisar de promoción para renovación.",
        },
        { divider: true, insert: true },
        {
          avatar: 'https://cdn.vuetifyjs.com/images/lists/2.jpg',
          title: 'Sosa, Julián Leandro',
          avisos: '',
          subtitle:
            "<span class='text--primary'>D.N.I. 39.161.715</span> &mdash; Moroso hace 2 meses",
        },
        { divider: true, insert: true },
      ],
      searchResultActions: [
        { icon: 'history', title: 'Ver Historial' },
        { icon: 'account_balance', title: 'Ver Cuenta Corriente' },
        { icon: 'person', title: 'Ver Legajo' },
      ],
      selectedPersonaId: '',
      selectedPersonaDocumento: '',
      showListaCreditos: false,
      showLegajoVirtual: false,
      showAlertas: false,
      selectedPersona: {},
      resetPagination: false,
    };
  },
  created() {
    this.searchField = this.UiCustomUserSettings.busquedaPersonaPor;
  },
  watch: {
    pagination: {
      handler() {
        if (!this.resetPagination) this.search();
      },
      deep: true,
    },
    searchField: {
      handler() {
        this.resetPagination = true;
        this.searchValue = '';
      },
    },
  },
  computed: {
    ...mapGetters(['UiCustomUserSettings', 'checkCanAccess', 'user']),
    pages() {
      if (this.pagination.rowsPerPage == null || this.totalItems == null)
        return 0;

      return Math.ceil(this.totalItems / this.pagination.rowsPerPage);
    },
  },
  methods: {
    ...mapMutations([
      'setActiveTask',
      'setActiveSubTask',
      'alertClear',
      'alertSuccess',
      'alertWarning',
      'alertError',
    ]),
    searchValueKeyUp(e) {
      if (e.keyCode === 13) {
        this.search();
      }
    },
    async verCreditos(item) {
      this.selectedPersonaId = item.personaId;
      this.showListaCreditos = true;

      var params = {
        width: 900,
        visible: true,
        personaId: item.personaId,
      };

      this.setActiveTask({ task: 'app-lista-creditos', props: params });
    },
    async verResumenEjecutivo(item) {
      this.selectedPersonaId = item.personaId;

      if (this.selectedPersonaId == null) {
        this.alertWarning(
          'Por favor, primero seleccione un crédito de la lista.'
        );
        return;
      }

      var params = {
        width: 900,
        visible: true,
        personaId: item.personaId,
      };

      this.setActiveTask({ task: 'app-resumen-ejecutivo', props: params });
    },
    async verContactos(item) {
      this.selectedPersonaId = item.personaId;

      var params = {
        width: 700,
        visible: true,
        personaId: item.personaId,
      };

      this.setActiveTask({ task: 'app-log-contactos', props: params });
    },
    async verInfo(item) {
      this.selectedPersona = item;
    },
    async verLegajoVirtual(item) {
      this.selectedPersonaId = item.personaId;
      this.selectedPersonaDocumento = item.documento;
      this.showLegajoVirtual = true;
    },
    // async verContactos(item){
    //   this.selectedPersonaId = item.personaId;
    //   var params = {
    //       width:900,
    //       visible: true,
    //       personaId: item.personaId
    //     };

    //     this.setActiveTask({task:'app-contactos-persona', props: params})
    // },
    async search() {
      try {
        if (this.searchValue == '') {
          this.alertWarning(
            'Por favor, ingrese un ' + this.searchField + ' a buscar.'
          );
          return;
        }

        this.selectedPersona = {};

        // valido el dato a buscar en base a qué se busca
        if (this.searchField == 'Documento') {
          if (isNaN(this.searchValue)) {
            const res = await this.$dialog.confirm({
              text:
                'Estás consultando por Documento, pero no ingresaste un número válido, ¿puede ser que hayas querido buscar por Nombre?',
              title: 'Atención',
              persistent: true, // Parece que no funciona...
            });

            if (!res) {
              return;
            } else {
              this.searchField = 'Nombre';
            }
          }
        } else if (this.searchField == 'Cuil') {
          if (isNaN(this.searchValue)) {
            const res = await this.$dialog.confirm({
              text:
                'Estás consultando por Cuil, pero no ingresaste un número válido, ¿puede ser que hayas querido buscar por Nombre?',
              title: 'Atención',
              persistent: true, // Parece que no funciona...
            });

            if (!res) {
              return;
            } else {
              this.searchField = 'Nombre';
            }
          } else {
            if (this.searchValue.length != 11) {
              this.alertWarning(
                'Por favor, ingrese los 11 dígitos del Cuil o  Cuit.'
              );
              return;
            }
          }
        } else if (this.searchField == 'Nombre') {
          if (!isNaN(this.searchValue)) {
            // está buscando x nombre, pero ingresó un número
            if (this.searchValue.length == 8) {
              // veo si no quiso poner un documento de identidad
              const res = await this.$dialog.confirm({
                text:
                  'Estás consultando por Nombre, pero pusiste todos números, ¿puede ser que hayas querido buscar por Documento?',
                title: 'Atención',
                persistent: true, // Parece que no funciona...
              });

              if (!res) {
                return;
              } else {
                this.searchField = 'Documento';
              }
            }
          }
        }

        this.loading = true;

        if (this.resetPagination) this.pagination.page = 1;

        var searchApi = '';
        switch (this.searchField) {
          case 'Documento':
            searchApi =
              'personas/listapordocumento?limit=' +
              this.pagination.rowsPerPage +
              '&page=' +
              this.pagination.page +
              '&withAvisos=true&withAvatars=false&documento=';
            break;
          case 'Cuil':
            searchApi =
              'personas/listaporcui?limit=' +
              this.pagination.rowsPerPage +
              '&page=' +
              this.pagination.page +
              '&withAvisos=true&withAvatars=false&cui=';
            break;
          case 'Nombre':
            searchApi =
              'personas/listapornombre?limit=' +
              this.pagination.rowsPerPage +
              '&page=' +
              this.pagination.page +
              '&withAvisos=true&withAvatars=false&nombre=';
            break;
          case 'Operacion':
            searchApi =
              'personas/listapornumerocredito?limit=' +
              this.pagination.rowsPerPage +
              '&page=' +
              this.pagination.page +
              '&withAvisos=true&withAvatars=false&numeroCredito=';
            break;
        }

        // limpio la lista
        this.searchResults = [];

        var result = await http.get(searchApi + this.searchValue); // traigo todas

        Vue.$log.debug(result);

        this.items = result.list;
        this.totalItems = result.totalCount;

        this.searchResults.push({ header: 'Resultados' });

        if (this.totalItems == 0) {
          // avisar que no se encontró
          this.alertWarning(
            'No se encontraron registros con los datos ingresados.'
          );
          this.isVisible = false;
        } else {
          // transformo el resutado en items para la lista
          for (let index = 0; index < this.items.length; index++) {
            const element = this.items[index];

            if (element.tipoPersonaId == 1) {
              //Persona Física
              this.searchResults.push({
                avatar: '',
                title: element.nombreCompleto,
                personaId: element.id,
                documento: element.documento,
                viewLegajo: '/legajo-persona/' + element.id,
                subtitle:
                  "<span class='text--primary'>" +
                  element.documentoCompleto +
                  '</span> &mdash; ' +
                  element.situacion,
                masInfo: element.situacion,
                avisos: element.avisos,
                cuentasBanco: element.cuentasBanco,
                clasificacion: element.clasificacionResumida,
                clasificacionColor: element.clasificacionColor,
                alertas: element.alertasFull,
                tieneReclamoActivo: element.tieneReclamoActivo,
              });
            } else {
              //Persona Jurídica
              this.searchResults.push({
                avatar: 'domain',
                title: element.nombre,
                personaId: element.id,
                documento: element.documento,
                viewLegajo: '/legajo-persona-juridica/' + element.id,
                subtitle:
                  "<span class='text--primary'>" +
                  'CUIT: ' +
                  element.cui +
                  '</span> &mdash; ' +
                  element.situacion,
                masInfo: element.situacion,
                avisos: element.avisos,
                cuentasBanco: element.cuentasBanco,
                clasificacion: element.clasificacionResumida,
                clasificacionColor: element.clasificacionColor,
                alertas: element.alertasFull,
              });
            }

            this.searchResults.push({ divider: true, insert: true });
          }

          //alert(JSON.stringify(this.user));

          if (this.totalItems == 1) {
            if (
              this.searchResults[1].alertas &&
              this.searchResults[1].alertas.length > 0 &&
              this.user.login.toString().toLowerCase() != 'jbelizan'
            ) {
              this.verAlertas(this.searchResults[1]);
            }
          }
        }
      } catch (error) {
        // Error
        this.alertWarning(error);
      }

      this.loading = false;
      this.resetPagination = false;
    },
    verAlertas(item) {
      this.selectedPersona = item;
      this.showAlertas = true;
    },
    /*  estaEnListaNegra(item){
      console.log(item);
      if(item.avisos && item.avisos.includes('Lista negra'))
      {
        console.log(true);
        return true;
      }
      return false;
    } */
  },
};
</script>
